import './resources/css/normalize.css';
import './resources/css/grid.css';
import './resources/css/ionicons.min.css';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Match, Miss } from 'react-router';
import App from './App';
import './index.css';

import AboutMePage from './AboutMePage';
import CoursesOfferedPage from './CoursesOfferedPage';
import NotFound from './components/NotFound'

const Root = () => {
  return (
    <BrowserRouter>
      <div>
        <Match exactly pattern="/" component={App} />
        <Match exactly pattern="/about/:person" component={AboutMePage} />
        <Match exactly pattern="/courses/:courseName" component={CoursesOfferedPage} />
        <Miss component={NotFound} />
      </div>
    </BrowserRouter>
  )
}

render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js